<template>
  <BasicLayout :left="left" :middle="middle" :right="right">
    <template v-slot:right_view>
      <div class="h100vh-100">
        <ToolBar :reflashBtn="reflashBtn" :queryBtn="queryBtn" :exportBtn="exportBtn" @notice="notice"></ToolBar>
        <div class="h100-40 h-scroll">
          <ejs-grid :allowPaging="true" ref="grid" :allowResizing="true" :pageSettings="pageSettings"></ejs-grid>
          <ejs-pager ref="pager" :pageSize="pageSettings.pageSize" :pageCount="pageCount" @click="getLogList"></ejs-pager>
        </div>
        <CustomDialog ref="searchDialog" v-bind:element="searchDialog.element" v-bind:styles="searchDialog.styles">
          <template v-slot:dialog-content>
            <AdvancedSearch ref="advancedSearch" v-bind:signInOrOperation="signInOrOperation" @childProps="getChildProps"></AdvancedSearch>
          </template>
        </CustomDialog>
      </div>
    </template>
  </BasicLayout>
</template>

<script>
import BasicLayout from "../../layouts/BasicLayout";
import CustomDialog from "../../components/common/CustomDialog";
import ToolBar from "../../components/security/logManager/ToolBar";
import AdvancedSearch from "../../components/security/logManager/AdvancedSearch";
import { Resize } from "@syncfusion/ej2-vue-grids";

export default {
  name: "LogManager",
  data() {
    return {
      left: { show: false, name: "" },
      middle: { show: false, name: "" },
      right: { show: true, crumb: `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.logManage')}` + '/' + `${this.$t('Security.loginLog')}` },
      reflashBtn: true,
      queryBtn: true,
      exportBtn: false,
      signInOrOperation: 0, // 登录日志 0 / 操作日志 1
      pageSettings: { pageSize: 15 },
      pageCount: 4,
      childParams: {},
      signInColumns: [
        { field: "logId", visible: false },
        { field: "accountName", headerText: `${this.$t('Security.User.username')}`, textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "execTypeShow", headerText: `${this.$t('Security.Log.execType')}`, textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "resultShow", headerText: `${this.$t('Security.Log.loginResult')}`, textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "execTime", headerText: `${this.$t('Security.Log.loginTime')}`, format: "yyyy/MM/dd HH:mm:ss", type: "date", textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" }
      ],
      operationColumns: [
        { field: "logId", visible: false },
        { field: "accountName", headerText: `${this.$t('Security.User.username')}`, textAlign: "Center", width: 360, minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "moduleName", headerText: `${this.$t('Security.Log.module')}`, textAlign: "Center", width: 480, minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "featureName", headerText: `${this.$t('Security.Log.feature')}`, textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "resultShow", headerText: `${this.$t('Security.Log.result')}`, textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" },
        { field: "execTime", headerText: `${this.$t('Security.Log.execTime')}`, format: "yyyy/MM/dd HH:mm:ss", type: "date", textAlign: "Center", minWidth: 100, clipMode: "EllipsisWithTooltip" }
      ],
      queryOrExport: 0,
      searchDialog: {
        element: {
          target: "#app",
          isClose: true,
          refName: "search",
          buttonGroup: [
            {
              click: this.dialogHide,
              buttonModel: { content: `${this.$t('Common.cancel')}` }
            },
            {
              click: this.confirm,
              buttonModel: { content: `${this.$t('Common.ok')}`, isPrimary: true }
            }
          ],
          title: `${this.$t('Common.adSearch')}`
        },
        styles: {
          width: "810px",
          height: "auto",
          model: true,
          visible: false
        }
      }
    };
  },
  methods: {
    setBasicTitle() {
      const id = this.$route.params.id;
      if (id === "1") {
        this.right.crumb = `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.logManage')}` + '/' + `${this.$t('Security.loginLog')}`;
        this.exportBtn = false;
        this.signInOrOperation = 0;
        this.$refs.grid.ej2Instances.columns = this.signInColumns;
      } else {
        this.right.crumb = `${this.$t('Security.securityManage')}`+'/' + `${this.$t('Security.logManage')}` + '/' + `${this.$t('Security.operateLog')}`;
        this.exportBtn = true;
        this.signInOrOperation = 1;
        this.$refs.grid.ej2Instances.columns = this.operationColumns;
      }
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.childParams = {};
    },
    notice(btn) {
      if (btn === "reflash") {
        this.reflashFunc();
      }
      if (btn === "query") {
        this.queryOrExport = 0;
        this.showFunc();
      }
      if (btn === "export") {
        this.queryOrExport = 1;
        this.showFunc();
      }
    },
    reflashFunc() {
      this.$refs.pager.ej2Instances.currentPage = 1;
      this.childParams = {};
      this.getLogList();
    },
    showFunc() {
      // 高级搜索，弹出层
      if (this.queryOrExport === 0) {
        this.searchDialog.element.title = `${this.$t('Common.adSearch')}`;
      } else{
        this.searchDialog.element.title = `${this.$t('Common.export')}`;
      }
      this.$refs.searchDialog.show();
    },
    exportFunc() {
      const That = this;
      const time = this.childParams.time;
      if (time == null || time == '') {
        this.$parent.showToast('warning',`${this.$t('Security.exportTimeNotNull')}`);
        return null;
      }
      time[0].setHours(0)
      time[0].setMinutes(0)
      time[0].setSeconds(0)
      time[1].setHours(23)
      time[1].setMinutes(59)
      time[1].setSeconds(59)
      const url = '/lte/ems/log/exportOperateLog';
      const params = {
        accountName: this.childParams.userName,
        //moduleId: this.childParams.dropdownList,
        action: '',
        startTime: time[0].getTime(),
        endTime: time[1].getTime()
      };
      const paramstring = '?accountName=' + params.accountName + '&action=""&startTime=' + params.startTime + '&endTime=' + params.endTime;
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url + paramstring;
      document.body.appendChild(link);
      link.click();
      this.$layer.confirm({
        msg: `${this.$t('Security.deleteLog')}`,
        btn1: {
          msg: That.$t('Common.confirm'),
          func: That.delOperationLog
        }
      });
    },
    dialogHide() {
      this.$refs.searchDialog.clear();
      this.$refs.searchDialog.close();
    },
    confirm() {
      this.$refs.searchDialog.close();
      if (this.queryOrExport === 0) {
        this.$refs.pager.ej2Instances.currentPage = 1;
        this.getLogList();
      } else {
        this.exportFunc();
      }
    },
    getLogList() {
      const pageNo = this.$refs.pager.ej2Instances.currentPage;
      let url = "";
      let params = { params: {} };
      let startTime = "";
      let endTime = "";
      if (this.childParams.time != null && this.childParams.time != "") {
        const time = this.childParams.time;
        time[0].setHours(0)
        time[0].setMinutes(0)
        time[0].setSeconds(0)
        time[1].setHours(23)
        time[1].setMinutes(59)
        time[1].setSeconds(59)
        startTime = time[0].getTime();
        endTime = time[1].getTime();
      }
      params.params.pageNo = pageNo;
      params.params.pageSize = this.pageSettings.pageSize;
      if (this.signInOrOperation === 0) {
        url = "/lte/ems/log/queryLoginLog";
        params.params.accountName = this.childParams.userName;
        params.params.result = this.childParams.dropdownList;
        params.params.startTime = startTime;
        params.params.endTime = endTime;
      } else {
        url = "/lte/ems/log/queryOperateLog";
        params.params.accountName = this.childParams.userName;
        params.params.moduleId = this.childParams.dropdownList;
        params.params.startTime = startTime;
        params.params.endTime = endTime;
      }
      let That = this;
      this.axios.get(url, params).then(response => {
        let result = response.data.result;
        result.forEach((v) => {
          let date = new Date();
          date.setTime(v.execTime);
          v.execTime = date;
        })
        That.$refs.grid.ej2Instances.dataSource = result;
        That.$refs.pager.ej2Instances.totalRecordsCount = response.data.totalCount;
      });
    },
    getChildProps(data) {
      this.childParams = data;
    },
    delOperationLog() {
      const url = "/lte/ems/log/deleteOperateLog";
      const time = this.childParams.time;
      time[0].setHours(0)
      time[0].setMinutes(0)
      time[0].setSeconds(0)
      time[1].setHours(23)
      time[1].setMinutes(59)
      time[1].setSeconds(59)
      const params = {
        accountName: this.childParams.userName,
        //moduleId: this.childParams.dropdownList,
        startTime: time[0].getTime(),
        endTime: time[1].getTime(),
      };
      let That = this;
      this.axios.post(url, params).then(response => {
        // 删除操作日志 后台void
        this.$refs.pager.ej2Instances.currentPage = 1;
        this.childParams = {}
        That.getLogList();
      });
    }
  },
  components: {
    BasicLayout,
    CustomDialog,
    ToolBar,
    AdvancedSearch
  },
  watch: {
    $route(to, from) {
      this.setBasicTitle();
      this.getLogList();
    }
  },
  mounted() {
    this.setBasicTitle();
    this.getLogList();
  },
  provide: {
      grid: [Resize]
  }
};
</script>
